import T from './T'

export default T
